import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/dorm-room-movers-college-moving-storage.jpg'),
    alt: 'dorm room movers college moving storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'dorm room movers college moving storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Dorm Room <span>Movers</span><span>for College Moving</span>',
  description:
    'ShipAndStorage provides seamless and reliable dorm room moving and storage solutions for college students. We ensure hassle-free transportation and secure storage, letting you focus on school life.',
  points: [
    'Up to 6 Months Free Storage',
    'Free Insurance up to $250',
    '1 Small Box to 100 Large Box Storage',
    'Storage Services with Freedom'
  ],
  image: {
    url: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/hero-image.svg',
    alt: 'dorm room movers college moving storage page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Sign Up' }
}

export const helperGuideSection = {
  title: 'How We Ensure Fast Dorm Room Moving and Storage Services',

  ctaButton: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Learn More' },
  cards: [
    {
      id: 1,
      title: 'Book Online',
      description:
        'Schedule your move online and let our dorm room movers handle the rest. Enjoy a seamless and hassle-free process.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/book-online-service.svg',
        alt: 'Book Online service'
      }
    },

    {
      id: 2,
      title: 'Arrange Pickup & Delivery',
      description:
        'Let our professionals safely pack and transport your items. Experience stress-free moving and storage with care for all your belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/arrange-pickup-&-delivery.svg',
        alt: 'Arrange Pickup & Delivery service'
      }
    },
    {
      id: 3,
      title: 'Choose Flexible Storage',
      description:
        'Select the storage solution that fits your needs, from a few boxes to larger items. Get customized options to match your requirements.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/choose-flexible-storage.svg',
        alt: 'Choose Flexible Storage service'
      }
    },
    {
      id: 4,
      title: 'Affordable and Fast  Dorm Moving Services',
      description:
        "At ShipAndStorage, we know that college life can be hectic and costly. That's why we provide affordable dorm moving services without compromising on speed or quality. Our dorm room movers work efficiently to get your items moved and stored, all while keeping costs student-friendly and transparent.",
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/affordable-and-fast-dorm-moving-services.svg',
        alt: 'Affordable and Fast  Dorm Moving Services service'
      }
    }
  ]
}

export const whySelfStoragesSectionContent = {
  title: 'Why Self Storage Service Is Necessary?',

  cards: [
    {
      id: 1,
      title: 'Free Up Your Space',
      description:
        "Maximize your home or office's potential by stowing away items you don’t use regularly. Our storage services help create a more organized and inviting environment.",
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/free-up-your-space.svg',
        alt: 'Free Up Your Space'
      }
    },
    {
      id: 2,
      title: 'Hassle-Free Moving and Transitioning',
      description:
        "Transitioning between locations is easier with temporary storage for your belongings. Keep your essential items safe until you're ready to move.",
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/hassle-free-moving-and-transitioning.svg',
        alt: 'Hassle-Free Moving and Transitioning'
      }
    },
    {
      id: 3,
      title: 'Reliable Storage for Seasonal and Personal Items',
      description:
        'Store seasonal decorations, sports equipment, or cherished items securely in our facilities, available for both short and extended periods.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/reliable-storage-for-seasonal-and-personal-items.svg',
        alt: 'Reliable Storage for Seasonal and Personal Items'
      }
    }
  ]
}

export const gridSectionContent = {
  title: 'Who Should Choose ShipAndStorage Service for College Moving?',

  cards: [
    {
      id: 1,
      title: 'Students Moving to Campus',
      description: 'Make your move-in easier by shipping items directly to your new dorm, ready for arrival.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/students-moving-to-campus.svg',
        alt: 'Students Moving to Campus'
      }
    },
    {
      id: 2,
      title: 'Graduating Students Relocating',
      description:
        'Streamline your move to a new city or job location by securely shipping and storing your belongings.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/graduating-students-relocating.svg',
        alt: 'Graduating Students Relocating'
      }
    },
    {
      id: 3,
      title: 'International & Out-of-State Students',
      description: 'Avoid the hassle of cross-country or international moves by storing or shipping items near campus.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/international-out-of-state-students.png',
        alt: 'International & Out-of-State Students'
      }
    },

    {
      id: 4,
      title: 'Students Changing Residences',
      description: 'Whether switching dorms or moving off-campus, use our service to simplify the transition.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/students-changing-residences.svg',
        alt: 'Students Changing Residences'
      }
    },
    {
      id: 5,
      title: 'Gap Semester Students',
      description: 'Take time off without worry—store or ship your belongings securely until you’re back.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/gap-semester-students.png',
        alt: 'Gap Semester Students'
      }
    },
    {
      id: 6,
      title: 'Study Abroad Participants',
      description: 'Store your belongings while you’re overseas, ready for when you return to campus.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/study-abroad-participants.svg',
        alt: 'Study Abroad Participants'
      }
    }
  ]
}

export const evenOddList = {
  title: 'Our Different Storage Services',
  description: '',

  articles: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Tailored for businesses, our storage options help you manage inventory and office supplies efficiently, allowing for quick access and organization.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-self-storage/business-storage-solution.svg',
        alt: 'Business Storage Solution'
      },
      link: {
        text: 'Explore Business Storage',
        href: PUBLIC_MAIN_ROUTES.BUSINESS_STORAGE.href
      }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Perfect for those in transition, our moving storage services accommodate your belongings during relocations, providing flexibility and convenience.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-self-storage/moving-storage-solution.svg',
        alt: 'Moving Storage Solution'
      },
      link: {
        text: 'Explore Moving Storage',
        href: PUBLIC_MAIN_ROUTES.MOVING_STORAGE_SOLUTIONS.href
      }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Travel light with our shipping services for luggage and boxes. We ensure safe delivery to your destination, so you can focus on your journey.',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-self-storage/luggage-and-box-shipping-services-solution.svg',
        alt: 'Luggage and Box Shipping Services'
      },
      link: {
        text: 'Explore Luggage & Box Shipping',
        href: PUBLIC_MAIN_ROUTES.LUGGAGE_BOX_SHIPPING_SERVICES.href
      }
    },
    {
      id: 4,
      title: 'Residential Storage Solution',
      description:
        'Our Residential Storage Solution provides secure, climate-controlled storage for your personal belongings during moves, renovations, or downsizing. ',
      image: {
        src: '/images/v2/pages/landing-pages/ship-to-self-storage/residential-storage-solution.svg',
        alt: 'Residential Storage Solution'
      },
      link: {
        text: 'Explore Residential Storage',
        href: PUBLIC_MAIN_ROUTES.RESIDENTIAL_STORAGE.href
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose ShipAndStorage for Dorm Room Movers?',
  description: '',

  cards: [
    {
      id: 1,
      title: 'Reliable and Trusted',
      description:
        'ShipAndStorage has years of experience in college moving and storage services, making us a trusted partner for students nationwide. We understand the needs of college students and offer reliable solutions tailored for dorm moves.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/reliable-and-trusted.svg',
        alt: 'Reliable and Trusted'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Plans',
      description:
        "Our dorm room moving services come with flexible storage options to fit your specific needs. Whether you need short-term or long-term storage, we've got you covered with plans designed to make student life easier.",
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/flexible-storage-plans.svg',
        alt: 'Flexible Storage Plans'
      }
    },
    {
      id: 3,
      title: 'Student-Focused Pricing',
      description:
        'Affordability is key for college students, and ShipAndStorage offers budget-friendly pricing with no hidden costs. We provide cost-effective dorm moving and storage solutions that fit your student budget.',
      image: {
        src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/student-focused-pricing.svg',
        alt: 'Student-Focused Pricing'
      }
    }
  ]
}

export const infoBannerSectionContent = {
  id: 1,
  title: 'Dorm Room Movers for Fast College Moving and Storage',
  description:
    'Dorm room movers for college students. Fast, affordable services for moving and storing your belongings quickly and securely.',
  image: {
    src: '/images/v2/pages/landing-pages/dorm-room-movers-college-moving-storage/dorm-room-movers-for-fast-college-moving-and-storage.svg',
    alt: 'Dorm Room Movers for Fast College Moving and Storage'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Started' }
}

export const faqSectionContent = {
  title: 'Our Shipping Partners',
  description:
    'At ShipAndStorage, we deliver world-class shipping and storage services through our trusted global partners: FedEx, DHL, and UPS. These industry leaders ensure that your belongings are transported securely and on time, no matter where they’re headed.',
  questions: [
    {
      id: 1,
      question: 'FedEx',
      answer:
        'Founded by Frederick W. Smith in 1971, FedEx began with just 186 packages and has since become a global logistics powerhouse. Operating a fleet of 696 aircraft and 215,000 vehicles, FedEx processes 16 million shipments daily across more than 220 countries. With over 550,000 employees and 5,000 centers worldwide, FedEx is committed to providing reliable and timely delivery services.|||Disclaimer|||This page was last updated in September 2024 for reference purposes only. FedEx makes no warranties regarding the accuracy or completeness of the information provided.|||For more details, visit FedEx.com. FedEx® is a registered trademark. © 1995-2024 FedEx.'
    },

    {
      id: 2,
      question: 'DHL',
      answer:
        'DHL Express, a key division of Deutsche Post DHL Group, is a global leader in international shipping and logistics. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL has become integral to the global supply chain, handling over 1.8 billion parcels annually. With operations in more than 220 countries, DHL ensures fast and reliable shipping worldwide.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. DHL makes no warranties regarding the accuracy of the information provided.'
    },
    {
      id: 3,
      question: 'UPS',
      answer:
        'Established in 1907 as the American Messenger Company, UPS re-branded as United Parcel Service (UPS) in 1919. Today, UPS delivers 25 million packages daily to over 220 countries and territories. Supported by more than 500,000 employees, UPS is one of the largest global logistics companies, offering unmatched reach and reliability.|||Disclaimer:|||This page was last updated in September 2024 for reference purposes only. UPS makes no warranties regarding the accuracy of the information provided.'
    }
  ]
}
